import { OrganizationItem } from '@cibo/core'
import { useFigures } from '@cibo/ui'
import { GridValueFormatterParams, GridValueGetterParams } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useOrgColumns = () => {
  const { t } = useTranslation('@cibo/profile/PaginatedOrgsTable')
  const { acres } = useFigures()

  return useMemo(
    () => ({
      name: {
        field: 'orgName',
        headerName: t('organization'),
        minWidth: 150,
        flex: 1,
        valueGetter: (params: GridValueGetterParams<string, OrganizationItem>) =>
          params.row.orgInfo.orgName,
      },
      userCount: {
        field: 'userCount',
        headerName: t('userCount'),
        minWidth: 100,
      },
      registeredUserCount: {
        field: 'registeredUserCount',
        sortable: false,
        headerName: t('registeredUserCount'),
        minWidth: 100,
      },
      fieldCount: {
        field: 'fieldCount',
        headerName: t('fieldCount'),
        valueGetter: (params: GridValueGetterParams<string, OrganizationItem>) =>
          params.row?.fieldCount?.fields,
        minWidth: 100,
      },
      acres: {
        field: 'acres',
        sortable: false,
        headerName: t('totalAcres'),
        valueGetter: (params: GridValueGetterParams<number, OrganizationItem>) =>
          params.row?.fieldCount?.acres,
        valueFormatter: (params: GridValueFormatterParams<number>) =>
          params.value && acres(params.value),
        minWidth: 100,
      },
    }),
    [t]
  )
}
